import { TYPES } from '@/modules/Education/Teach/constants';

import Action from '@/models/list/Action';

import APIService from '@/services/APIService';

export default {

  getMessages(id, params) {
    return APIService.get(`/chat/${id}`, { params });
  },

  sendMessage(chatId, data) {
    return APIService.post(`/chat/${chatId}`, data);
  },

  closeChat(chatId) {
    return APIService.post(`/chat/${chatId}/close`);
  },

  getRoomGroup(id) {
    return APIService.post(`/group/${id}/chat-room`);
  },

  getRoomCourse(id, params) {
    return APIService.post(`/course/${id}/chat-room`, params);
  },

  getChatTags(id) {
    return APIService.get(`/chat/${id}/tags`);
  },

  getConsultations(data, params) {
    return APIService.post('/consultations', data,
      {
        rOptions: {
          model: Action,
          many: true,
          itemParse: (i) => ({
            course: i.course_id ? { id: i.course_id, title: i.course_name } : null,
            unit: i.course_unit_id ? { id: i.course_unit_id, title: i.course_unit_name } : null,
            lesson: i.lesson_id ? { id: i.lesson_id, title: i.lesson_name } : null,

            user: { id: i.user_id, full_name: i.user_name },
            chatId: i.chat_id,
            date: `${i.message_created_at.split(' ').join('T')}.000000Z`,
            type: TYPES.consultation,
          }),
        },
        params,
      },
      { });
  },

  getUnreadConsultations(params) {
    return APIService.post('/consultations/exists-unread-messages', params);
  },

  getUnreadConsultationsByTag(tag, userId) {
    return this.getUnreadConsultations({
      tags: [tag],
      ...userId ? { user_id: userId } : {},
    });
  },
};
